module.exports = __webpack_public_path__ + "fonts/u-WUoqrET9fUeobQW7jkRYX0hVgzZQUfRDuZrPvH3D8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/u-WUoqrET9fUeobQW7jkRYX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = 383
// module chunks = 0